import { PageId } from 'constants/pages'

export const enum PageIdStylioArch61 {
  SUBSCRIPTIONS_ARCH_61 = PageId.SUBSCRIPTIONS_ARCH_61,
  SUB_UPSELL_ARCH_61 = PageId.SUB_UPSELL_ARCH_61,
  FACE_STYLING_PDF_UPSELL_ARCH_61 = PageId.FACE_STYLING_PDF_UPSELL_ARCH_61,
  PROPORTIONS_PDF_UPSELL_ARCH_61 = PageId.PROPORTIONS_PDF_UPSELL_ARCH_61,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
  DOWNLOAD_ARCH_61 = PageId.DOWNLOAD_ARCH_61,
}
